export default __webpack_public_path__ + "bc61586f30906d283e48120415d995d0.ogg";